import React from 'react';
import {Col} from 'antd';
import DocumentMeta from 'react-document-meta';
import {CusImage, Section, PageHeader} from '../common'
import Image1 from '../img/ms1.jpg';
import Image2 from '../img/ms2.jpg';
import Image3 from '../img/ms3.jpg';
import {mastersMeta} from '../constants/meta';

const Masters = () => {
  return (
    <DocumentMeta {...mastersMeta}>
      <PageHeader title="Магистри" />
      <Section>
        <Col md={16}>
          <h2>Магистърски тези / дипломни работи</h2>
          <p>Предлагаме индивидуално <strong>разработване на магистърски тези</strong> и <strong>изготвяне на дипломни работи</strong> за всички икономически специалности при гарантирана уникалност на разработката, професионализъм и конфиденциалност. Помощ при формулиране на темата, изготвяне на примерно съдържание, корекции, презентация/резюме за защитата и <strong>отговор на рецензията</strong>.</p>

          <h2>Курсовa работи</h2>
          <p>Индивидуално <strong>разработване на различни по вид курсови работи</strong>, <strong>реферати</strong>, <storng>есета</storng>, доклади и др. за всички икономически специалности при зададено от Вас условие.</p>
        </Col>
        <Col style={{margin: "auto"}} xs={20} md={8}>
          <CusImage src={Image1} alt="Разработване на дипломна работа" />
        </Col>
      </Section>
      <Section background>
        <Col style={{margin: "auto"}} xs={20} md={8}>
          <CusImage src={Image2} frameStyle="top" alt="Решаване на изпити" />
        </Col>
        <Col md={16}>
          <h2>Казуси</h2>
          <p>Дългогодишният ни опит гарантира <strong>разработката на качествени казуси</strong> за всички икономически специалности за редовно и <strong>дистанционно обучение</strong>, отговарящи на изпратеното от Вас условие.</p>

          <h2>Тестове</h2>
          <p>Предлагаме помощ при <strong>решаване на тестове</strong> за <strong>изпити</strong> за всички икономически специалности.</p>
        </Col>
      </Section>
      <Section>
        <Col style={{margin: "auto"}} xs={20} md={16}>
          <h2>Дистанционно обучение</h2>
          <p>Може да разчитате на <strong>пълното ни съдействие в процеса на Вашето дистанционно обучение</strong> за всички икономически специалности, което включва <strong>разработване на исканите курсови задачи</strong> и помощ при <strong>полагане на тестове</strong>.</p>

          <h2>Excel</h2>
          <p>Извършване на разнообразни <strong>изчисления в Excel</strong>.</p>

          <h2>Power Point</h2>
          <p>Изготвяне на индивидуални <strong>презентации</strong>.</p>
        </Col>
        <Col md={8}>
          <CusImage src={Image3} frameStyle="full" alt="Дистанционно обучение" />
        </Col>
      </Section>
    </DocumentMeta>
  );
};

export default Masters;